import { useSettings } from '@wix/tpa-settings/react';
import { Text } from '@wix/wix-ui-tpa/cssVars';
import { useEnvironment } from '@wix/yoshi-flow-editor';
import type { FC } from 'react';
import React from 'react';

import { DataHook } from '../../../../../../types';
import settingsParams from '../../../../settingsParams';
import { IconsDesktop } from '../Icons';
import { classes } from './EmptyEditor.st.css';

interface EmptyEditorProps {
  setEditMode: (value: boolean) => void;
}

export const EmptyEditor: FC<EmptyEditorProps> = ({ setEditMode }) => {
  const settings = useSettings();
  const { isMobile } = useEnvironment();

  const handleClick = () => {
    setEditMode(true);
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleClick();
    }
  };

  const placeholder = settings.get(settingsParams.aboutDescriptionPlaceholder);

  return (
    <>
      <div
        className={isMobile ? classes.rootMobile : classes.root}
        onClick={handleClick}
        onKeyDown={handleKeyDown}
        tabIndex={0}
        data-hook={DataHook.EmptyEditor}
      >
        <Text tagName="div" className={classes.placeholder}>
          {placeholder}
        </Text>
        {!isMobile && <IconsDesktop />}
      </div>
    </>
  );
};
